import React from 'react';
import { tw } from '../../utils/tailwind';
import { Text, TextProps } from 'react-native';

export const Label = ({ children }: TextProps) => {
  return <Text style={tw`ml-4 mt-3 text-xs text-gray-500`}>{children}</Text>;
};
